import { type ReactElement } from 'react'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useCustomLocationManagementFeature } from '@hooks'
import { useProfile } from '@front/model'
import { NotReady } from '@components'
import { CustomLocationList } from './CustomLocationList'

function CustomLocationsAccess(): ReactElement {
  const { isAdmin } = useProfile()
  const feature = useCustomLocationManagementFeature()

  if (feature.isLoading) return <NotReady isLoading />
  if (!isAdmin || !feature.isEnabled) return <NotReady error='This feature is not available.' />
  // the detail route renders as a modal through the Outlet, keeping the list behind it
  return (
    <>
      <CustomLocationList />
      <Outlet />
    </>
  )
}

export const Route = createFileRoute('/location/list')({
  component: CustomLocationsAccess,
})
